export enum IVI {
    IVE = "ive",
    IVP = "ivp",
    INC = "inc",
    INV = "inv",
    INE = "ine",
    SND = "snd",
    EDP = "edp"
  }
  
  export const IVI_MESSAGES = {
    [IVI.IVE]: "Identidad validada exitosamente",
    [IVI.IVP]: "Identidad validada parcial",
    [IVI.INC]: "Identidad no coincidente",
    [IVI.INV]: "Identidad no vigente",
    [IVI.INE]: "Identidad no encontrada",
    [IVI.SND]: "Servicio no disponible",
    [IVI.EDP]: "Error de proceso"
  };

  export const IVI_MESSAGES_USUARIO = {
    [IVI.IVE]: "Los datos se confirmaron. Continúa el proceso de afiliación y si es necesario, adjunta los documentos que te pide el sistema.'",
    [IVI.IVP]: "Revisa los datos que ingresaste en los campos de “nombres, apellidos y fecha de nacimiento” y regístralos de nuevo de la misma manera que registra en el documento de identidad",
    [IVI.INC]: "No es posible realizar el proceso de afiliación. Los datos cargados no coinciden.",
    [IVI.INV]: "El documento de identidad digitado no se encuentra vigente. Verifica de nuevo o intenta con otro número para continuar con el proceso.",
    [IVI.INE]: "Verifica el tipo y número de documento e ingresa la información de nuevo de la misma manera que registra en el documento de identidad.",
    [IVI.SND]: "Se ha producido un fallo en la conexión con la Registraduría Nacional. Inténtalo más tarde.",
    [IVI.EDP]: "Se ha producido un fallo en proceso. Inténtalo más tarde."
  };